import React from "react";
import ReactDOM from "react-dom";
import AdForm from "./components/adverts/AdForm/AdForm";
import CvForm from "./components/recruitment/CvForm/CvForm";
import MarketplaceSignup from "./components/marketplace/signup/Signup";
import MarketplaceUpload from "./components/marketplace/upload/Upload";

const adForm = document.querySelector(".advert-form-root");
if (adForm) {
  ReactDOM.createRoot(adForm).render(<AdForm />)
}

const cvForm = document.querySelector(".cv-form-root");
if (cvForm) {
  ReactDOM.createRoot(cvForm).render(<CvForm />)
}

const marketplaceSignup = document.querySelector(".marketplace-signup-root");
if (marketplaceSignup) {
  ReactDOM.createRoot(marketplaceSignup).render(<MarketplaceSignup />)
}

const marketplaceUpload = document.querySelector(".marketplace-upload-root");
if (marketplaceUpload) {
  ReactDOM.createRoot(marketplaceUpload).render(<MarketplaceUpload />)
}